import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  CircularProgress,
  ClickAwayListener,
  Divider,
  Grid,
  Grow,
  IconButton,
  InputAdornment,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import {
  CheckBox,
  MoreHoriz,
  MoreHorizOutlined,
  MoreHorizRounded,
  RecentActorsRounded,
  Search,
  SearchOutlined,
} from "@material-ui/icons";
import React from "react";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";
import { IoMdAnalytics, IoMdContact } from "react-icons/io";
import { RiBillLine } from "react-icons/ri";
import { useStyles } from "./styles";
import ReactSelect from "react-select";
import { MdAddBox } from "react-icons/md";
import Backdrop from "../../components/Modal/Backdrop";
import Modal from "../../components/Modal/Modal";
import EditUserModal from "../../components/Modal/EditUserModal";
import { AiTwotoneDelete, AiTwotoneEdit } from "react-icons/ai";
import TicketsTableBody from "./TicketsTableBody";
import ticketServices from "./ticketServices";
import { Multiselect } from "multiselect-react-dropdown";

const options = [
  {
    value: 1,
    key: "Admin",
  },
  {
    value: 2,
    key: "Billing",
  },
  {
    value: 3,
    key: "Analytics",
  },
  {
    value: 4,
    key: "Recordings",
  },
];

function AllTickets(props: any) {
  const classes = useStyles();
  const [loading, setloading] = React.useState(false);
  const [permissions, setPermissions] = React.useState<any>([]);
  const [usersList, setUsersList] = React.useState<any>([]);
  const [addDepartment, setAddDepartment] = React.useState(false);
  const [updateUser, setUpdateUser] = React.useState(false);
  const [addNewUser, setAddNewUser] = React.useState(false);
  const anchorRef: any = React.useRef<any>(null);
  // const [open, setOpen] = React.useState<any>(true);
  const [openUsers, setOpenUsers] = React.useState<any>(true);
  const [updateData, setUpdateData] = React.useState<any>([]);
  const [updateUserId, setupdateUserId] = React.useState<any>([]);
  const [selecteduserId, setsSelecteduserId] = React.useState<any>();
  const [selectedDeparmentList, setSelectedDeparmentList] = React.useState<any>(
    []
  );
  const [userListdepartmentNumbers, setUserListdepartmentNumbers] =
    React.useState<any>([]);

  const editUserPermissions = (userId: any, data: any) => {
    // console.log("data", data)
    setupdateUserId(userId);
    setUpdateData(data);
    setUpdateUser(!updateUser);
  };
  const handleEditUser = () => {
    setUpdateUser(!updateUser);
  };
  const expandOpen = () => {
    setOpenUsers(!openUsers);
  };
  const handlePopUpAddDepartmentModal = (uerId: any, deparmentList: any) => {
    setsSelecteduserId(uerId);
    setAddDepartment(!addDepartment);
    setSelectedDeparmentList(deparmentList);
  };

  const fetchTicketsList = () => {
    setloading(true);
    ticketServices
      .fetchTickets()
      .then((res: any) => {
        // console.log("ticketsdata", res.data.docs)
        if (res.success) {
          setUsersList(res.data.docs);
          setUserListdepartmentNumbers(res.data.departmentNumbers);
          setloading(false);
        }
      })
      .catch((err: any) => {});
  };

  React.useEffect(() => {
    fetchTicketsList();
  }, []);

  const onChaneSelect = (e: any) => {
    // console.log(e)
    const arr: any = [];
    e.map((item: any) => {
      arr.push(item.value);
    });
    // console.log(arr)
    const filteredList: any = [];
    usersList.map((user: any) => {
      const permiss = user.permissions;
      arr.map((item: any) => {
        if (permiss?.includes(item)) {
          filteredList.push(user);
        }
      });
    });
    setUsersList(filteredList);
    // console.log("filteredList",filteredList)
    // setPermissions(arr)
  };

  const onRemoveSelect = (e: any) => {
    // console.log(e)
    const arr: any = [];
    e.map((item: any) => {
      arr.push(item.value);
    });
    // console.log(arr)
    if (arr.length === 0) {
      fetchTicketsList();
    } else {
      const filteredList: any = [];
      usersList.map((user: any) => {
        const permiss = user.permissions;
        arr.map((item: any) => {
          if (permiss?.includes(item)) {
            filteredList.push(user);
          }
        });
      });
      setUsersList(filteredList);
      // console.log("filteredList",filteredList)
    }
  };
  const [search, setSearch] = React.useState("");
  const hanldeUsersSearch = (e: any) => {
    // console.log(e.target.value)
    if (e.target.value === "") {
      fetchTicketsList();
    } else {
      setSearch(e.target.value);
      const results = usersList
        ?.filter((itm: any) =>
          itm.firstName?.toLowerCase().includes(search.toLowerCase())
        )
        .map((item: any, id: any) => {
          return item;
        });
      // console.log(results)
      setUsersList(results);
    }
  };

  return (
    <div className={classes.usersContainer}>

      {/* <Card className={classes.card} > */}
      <Accordion
        expanded={openUsers}
        className={classes.card}
        onChange={expandOpen}
      >
        <AccordionSummary
          expandIcon={
            openUsers ? (
              <FiMinusCircle color="lightgrey" />
            ) : (
              <FiPlusCircle color="lightgrey" />
            )
          }
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className={classes.users}>Chat Tickets List</Typography>
        </AccordionSummary>
        <Divider className={classes.divider} />
        <AccordionDetails
          style={{ display: "block", padding: "2px 30px 30px" }}
        >
          <Card className={classes.table}>
            <TableContainer style={{ overflowY: "auto", overflowX: "auto" }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.text}>ID</TableCell>
                    <TableCell className={classes.text}>Subject</TableCell>
                    <TableCell className={classes.text}>Customer Name</TableCell>
                    <TableCell className={classes.text}>Customer Email</TableCell>
                    <TableCell className={classes.text}>Channel</TableCell>
                    <TableCell className={classes.text}>Status</TableCell>
                    <TableCell className={classes.text}>Created On</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        marginLeft: 480,
                        marginTop: 80,
                        marginBottom: 40,
                      }}
                    >
                      <CircularProgress />
                    </Box>
                  ) : (
                    usersList?.map((item: any, i: any) => (
                      <TicketsTableBody
                        handlePopUpAddDepartmentModal={
                          handlePopUpAddDepartmentModal
                        }
                        editUserPermissions={editUserPermissions}
                        data={item}
                        fetchTicketsList={fetchTicketsList}
                        loading={loading}
                        key={i}
                        // userListdepartmentNumbers={userListdepartmentNumbers}
                      />
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </AccordionDetails>
      </Accordion>
      {/* </Card> */}
    </div>
  );
}

export default AllTickets;
